import { useMsal } from '@azure/msal-react';

export const useAuth = () => {
  const { instance, accounts, inProgress } = useMsal();
  
  const isAuthenticated = accounts.length > 0;
  const user = accounts[0] || null;
  
  return {
    isAuthenticated,
    user: user ? {
      email: user.username,
      name: user.name || user.username,
      id: user.localAccountId || user.homeAccountId,
    } : null,
    loading: inProgress !== 'none',
  };
};